// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__1B_jH","title__content":"Title_title__content__c-4mG"};